import { WebLeft, WebWidth } from "../../config/config";
import { F_Fammily } from "../../util/config-fonts";
import { isMobile } from "react-device-detect";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";

function DrawerSheetBottom({
  open,
  element,
  id = "DrawerClose",
  size = 260,
  Heading = "",
  displayCloseIcon,
  lockBackgroundScroll = true,
  closeFunction = () => {},
}) {
  return (
    <Drawer
      zIndex={40500}
      open={open}
      onClose={closeFunction}
      lockBackgroundScroll={lockBackgroundScroll}
      direction="bottom"
      duration={220}
      size={size}
      style={{
        height: `calc(100vh - 150px)`,
        left: isMobile ? 0 : WebLeft,
        right: isMobile ? 0 : "auto",
        width: isMobile ? "100%" : WebWidth,
        maxWidth: isMobile ? "100%" : WebWidth,
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 30,
          right: 20,
          fontSize: 18,
          display: displayCloseIcon,
          fontWeight: "bolder",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          color: "white",
          padding: "4px 9px",
          borderRadius: 20,
        }}
        id={id}
        onClick={closeFunction}
      >
        X
      </div>

      <div
        style={{
          position: "absolute",
          top: 35,
          left: "50%",
          transform: "translateX(-50%)",
          fontSize: 22,
          margin: 0,
          textAlign: "center",
          fontFamily: F_Fammily.Medium,
          fontWeight: "bold",
          width: 300,
          height: 50,
          overflow: "hidden",
          whiteSpace: "normal",
          wordWrap: "break-word",
        }}
      >
        {Heading}
      </div>

      <div style={{ height: 55 }}></div>
      <div
        style={{
          padding: 10,
          overflow: "auto",
          height: "90%",
          marginTop: "20px",
        }}
      >
        {element}
      </div>
    </Drawer>
  );
}
export default DrawerSheetBottom;
